import { apiFetch } from '../api-client';

export interface SalaryConfigData {
  workingDaysStandard: number;
  minWageRegion1: number;
  personalDeduct: number;
  dependentDeduct: number;
  version: string;
  effectiveFrom: string;
  updatedBy: string | null;
  notes: string | null;
}
export interface SalaryAllowance {
  id: string;
  code: string;
  name: string;
  taxFreeLabel: string;
  bhLabel: string;
  suggestedLabel: string;
  defaultAmount: number | null;
  active: boolean;
  sortOrder: number;
}
export const salaryConfigApi = {
  get: () => apiFetch<{ config: SalaryConfigData | null; allowances: SalaryAllowance[] }>('/api/salary-config'),
  patchConfig: (body: Partial<SalaryConfigData>) => apiFetch<SalaryConfigData>('/api/salary-config', { method: 'PATCH', body: JSON.stringify(body) }),
  addAllowance: (body: Omit<SalaryAllowance, 'id'>) => apiFetch<SalaryAllowance>('/api/salary-allowances', { method: 'POST', body: JSON.stringify(body) }),
  patchAllowance: (id: string, body: Partial<SalaryAllowance>) => apiFetch<SalaryAllowance>(`/api/salary-allowances/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  removeAllowance: (id: string) => apiFetch<{ ok: true }>(`/api/salary-allowances/${id}`, { method: 'DELETE' }),
};
